import type { Session } from '@/lib/types';
import { TrackBadge } from './TrackBadge';

type SessionDetailsDialogProps = {
  session: Session | null;
  onClose: () => void;
};

export function SessionDetailsDialog({ session, onClose }: SessionDetailsDialogProps) {
  if (session === null) {
    return null;
  }

  return (
    <div className="dialog-backdrop" onClick={onClose} role="presentation">
      <section
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="session-details-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="dialog__header">
          <div className="session-card__topline">
            <TrackBadge track={session.track} />
            <span className="session-card__format">{session.formatLabel}</span>
          </div>
          <button className="button button--ghost button--icon" type="button" onClick={onClose} aria-label="Details schließen">
            x
          </button>
        </div>

        <h3 id="session-details-title">{session.title}</h3>
        {session.subtitle ? <p className="dialog__lead">{session.subtitle}</p> : null}

        <dl className="session-card__meta">
          <div>
            <dt>Referentin</dt>
            <dd>{session.speaker ?? 'Wird noch ergänzt'}</dd>
          </div>
          <div>
            <dt>Raum</dt>
            <dd className="room-label">{session.room.name}</dd>
          </div>
          <div>
            <dt>Kapazität</dt>
            <dd>{session.isBookable ? `${session.remainingSeats} freie Plätze` : 'Nicht buchbar'}</dd>
          </div>
        </dl>

        <div className="dialog__content">
          {session.description?.split(/\n{2,}/).map((paragraph, index) => (
            <p key={`${session.id}-${index}`}>{paragraph.trim()}</p>
          ))}
        </div>
      </section>
    </div>
  );
}
